/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { NavLink } from 'react-router-dom';

import { Dropdown } from './styles';
import { Container } from '../../../assets/styles';

const DropdownMenu = ({ openChangeStoreModal, logout }) => (
  <div style={{ padding: '0 30px' }}>
    <Container style={{ padding: '0' }}>
      <Dropdown>
        <ul>
          <li><NavLink to="/dashboard/user/account" activeClassName="active">Meus dados</NavLink></li>
          <li><NavLink to="/dashboard/help" activeClassName="active">Central de ajuda</NavLink></li>
          <li><a href onClick={() => openChangeStoreModal()}>Alterar loja</a></li>
          <li><a href onClick={logout}>Sair</a></li>
        </ul>
      </Dropdown>
    </Container>
  </div>
);

export default DropdownMenu;
